import styled from 'styled-components';

const Ul = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export default Ul;
